import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const AlertStatus = ({ status, setStatus, onDismiss }) => {
  const { t: translate } = useTranslation();

  const onDismissInternal = () => {
    setStatus('idle');
    onDismiss();
  };

  useEffect(() => {
    if (status !== 'idle') {
      const timer = setTimeout(() => {
        setStatus('idle');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status, setStatus]);

  return (
    <div
      style={{
        position: 'fixed',
        top: '2.5rem',
        right: '2.5rem',
        zIndex: 9999,
        width: 'auto',
      }}
    >
      <Alert
        color="danger"
        className="w-auto"
        isOpen={status === 'error'}
        toggle={onDismissInternal}
        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
      >
        {translate('An unknown error occurred, please try again later.')}
      </Alert>
      <Alert
        color="success"
        className="w-auto"
        isOpen={status === 'saved'}
        toggle={onDismissInternal}
        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
      >
        {translate('Saved changes')}
      </Alert>
      <Alert
        color="success"
        className="w-auto"
        isOpen={status === 'added'}
        toggle={onDismissInternal}
        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
      >
        {translate('Added successfully')}
      </Alert>
      <Alert
        color="success"
        className="w-auto"
        isOpen={status === 'excluded'}
        toggle={onDismissInternal}
        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
      >
        {translate('Excluded successfully')}
      </Alert>
    </div>
  );
};

AlertStatus.propTypes = {
  status: PropTypes.oneOf(['idle', 'added', 'error', 'saved', 'excluded']).isRequired,
  setStatus: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default AlertStatus;
